// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".HorizontalRule_root__1T5VR {\n  background-color: var(--theme-horizontal-rule);\n  display: block;\n  border: none;\n  height: 1px;\n}\n", "",{"version":3,"sources":["webpack://src/auto/components/HorizontalRule/HorizontalRule.module.css"],"names":[],"mappings":"AAAA;EACE,8CAA8C;EAC9C,cAAc;EACd,YAAY;EACZ,WAAW;AACb","sourcesContent":[".root {\n  background-color: var(--theme-horizontal-rule);\n  display: block;\n  border: none;\n  height: 1px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": "HorizontalRule_root__1T5VR"
};
export default ___CSS_LOADER_EXPORT___;
